'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _feature = require('./feature.css');

var _feature2 = _interopRequireDefault(_feature);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Feature = function Feature(_ref) {
  var className = _ref.className,
      icon = _ref.icon,
      title = _ref.title,
      copy = _ref.copy;

  return _react2.default.createElement(
    'div',
    { className: className },
    _react2.default.createElement('img', { src: icon, alt: title }),
    _react2.default.createElement(
      'h3',
      { className: _feature2.default.title },
      title
    ),
    _react2.default.createElement('p', { className: _feature2.default.copy, dangerouslySetInnerHTML: { __html: copy } })
  );
};

Feature.propTypes = {
  className: _react.PropTypes.string,
  icon: _react.PropTypes.string.isRequired,
  title: _react.PropTypes.string.isRequired,
  copy: _react.PropTypes.string.isRequired
};

exports.default = Feature;


//////////////////
// WEBPACK FOOTER
// ./src/components/Feature/Feature.js
// module id = 93
// module chunks = 1